import { useLocation } from "react-router-dom";
import { UseGetResponsesApiFilters } from "../api/methods/use-get-responses-api";

export const appUrls = {
  home: "/",
  themes: "/themes",
  login: "/login",
  organization: "/organization",
  responses: "/responses",
  guidelines: "/guidelines",
  callback: "/callback",
};

export const useGetPageUrl = () => {
  const { search } = useLocation();

  const getHomeUrl = () => appUrls.home;

  const getLoginUrl = () => appUrls.login;

  const getResponsesUrl = (params: {
    organizationId: string;
    themeStructureId: string;
    filters?: UseGetResponsesApiFilters;
    shouldPersistSearch?: boolean;
  }): string => {
    const filtersToSearchParams: { [key: string]: string } = Object.entries(
      params.filters ?? {}
    ).reduce<{ [key: string]: string }>((acc, [key, value]) => {
      acc[key] = String(value);

      return acc;
    }, {});

    const newSearchParams = new URLSearchParams({
      themeStructureId: params.themeStructureId,
      ...filtersToSearchParams,
    });

    return `${appUrls.organization}/${params.organizationId}${
      appUrls.responses
    }${params.shouldPersistSearch ? search : "?" + newSearchParams.toString()}`;
  };

  const getResponseUrl = (params: {
    organizationId: string;
    responseId: string;
    shouldPersistSearch?: boolean;
  }): string => {
    return `${appUrls.organization}/${params.organizationId}${
      appUrls.responses
    }/${params.responseId}${params.shouldPersistSearch ? search : ""}`;
  };

  const getThemesUrl = (params: { organizationId: string }): string => {
    return `${appUrls.themes}/${params.organizationId}`;
  };

  const getGuidelinesUrl = (params: { organizationId: string }): string => {
    return `${appUrls.organization}/${params.organizationId}${appUrls.guidelines}`;
  };

  return {
    getHomeUrl,
    getLoginUrl,
    getResponsesUrl,
    getResponseUrl,
    getThemesUrl,
    getGuidelinesUrl,
  };
};
